import React from 'react';

function CustomerInfo({ context, onChange }) {
  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // Convert number inputs to actual numbers
    let newValue = value;
    if (type === 'number') {
      // Handle empty string or invalid numbers
      newValue = value === '' ? 0 : parseFloat(value);
      if (isNaN(newValue)) {
        newValue = 0;
      }
    }

    onChange({ ...context, [name]: newValue });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Customer Name *
        </label>
        <input
          type="text"
          name="customer"
          value={context.customer || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Vertical / Industry
        </label>
        <input
          type="text"
          name="vertical"
          value={context.vertical || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., Higher Education, Healthcare"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Lines of Business
        </label>
        <input
          type="text"
          name="lob"
          value={context.lob || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., Call Center, Service Desk"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          IPA Workshop Date
        </label>
        <input
          type="text"
          name="ipa_date"
          value={context.ipa_date || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., July 2025"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Cost per Agent ($)
        </label>
        <input
          type="number"
          name="cost_per_agent"
          value={context.cost_per_agent || 25}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="25"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Professional Services Price ($)
        </label>
        <input
          type="number"
          name="professional_services_price"
          value={context.professional_services_price || 0}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Bill of Materials Price ($)
        </label>
        <input
          type="number"
          name="bom_price"
          value={context.bom_price || 0}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Bill of Materials Length (months)
        </label>
        <input
          type="number"
          name="bom_length_months"
          value={context.bom_length_months || 0}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Estimated Monthly Usage Costs ($)
        </label>
        <input
          type="number"
          name="monthly_usage_costs"
          value={context.monthly_usage_costs || 0}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0"
        />
      </div>
    </div>
  );
}

export default CustomerInfo;
